import {
  JobParticipantEnum,
  JobUIStatusEnum,
  JobWorkflowStatusEnum,
  QuantityItem,
} from 'domains/workspaceDomain';
import { JobSharedItem, StartJobConfigParam } from './jobconfigDomain';
import { JobTypeEnum } from './workspaceDomain';

export enum PROJECT_LIST_TYPE_ENUM {
  CARD = 'CARD',
  TABLE = 'TABLE',
}

export enum PROJECT_STATUS_ENUM {
  ACTIVE = 'ACTIVE',
  COMPLETE = 'COMPLETE',
}

export enum PROJECT_EDIT_TYPE {
  COPY = 'COPY',
  DELETE = 'DELETE',
}

export enum ProjectJobAddFromEnum {
  SEARCH = 'SEARCH',
  SHOP_DROP_DOWN = 'SHOP_DROP_DOWN',
  SHOP_GALLERY = 'SHOP_GALLERY',
}

export interface EditProjectParam {
  project: Project;
  type: PROJECT_EDIT_TYPE;
}

export interface ProjectJobDetail {
  name: string;
  jobType: JobTypeEnum;
  participants: JobParticipantEnum[];
  sequence: number;
  price: number;
  deliveryTime: string;
  quantity: number;
  workflowStatus: JobWorkflowStatusEnum;
  jobConfigId: string;
  joinId: number;
  jobId: number;
  statusFilters: JobUIStatusEnum[];
  canAddToCart: boolean;
  itemType: JobProjectItemTypeEnum;
  quantityItems: QuantityItem[];
}

export enum JobProjectItemTypeEnum {
  JOB = 'JOB',
  JOB_CONFIG = 'JOB_CONFIG',
}

export interface ProjectJobSummary {
  id: string;
  jobType: JobTypeEnum;
  jobConfigId: string;
  jobId: string;
  joinId: string;
  name: string;
  workflowStatus: JobWorkflowStatusEnum;
}
export interface Project {
  id: string;
  orgId: string;
  projectName: string;
  projectStatus: PROJECT_STATUS_ENUM;
  copiedFromId: string;
  image: string;
  latestDeliveryTime: string;
  jobSummaries?: ProjectJobSummary[];
  jobDetails: ProjectJobDetail[];
  sharedWiths: JobSharedItem[];
}

export interface ProjectListParams {
  active: boolean;
  page: number;
  size: number;
  sort: string;
  isDesc: boolean;
}

export interface ProjectDeleteParams {
  id: string;
  deleteJobConfigIds: string[];
}

export interface ProjectCopyParams {
  id: string;
  copiedJoinIds: string[];
}

export interface JobProjectAddJobParams {
  projectId: string;
  jobId?: number;
  startParams?: StartJobConfigParam;
  addFrom?: ProjectJobAddFromEnum;
}
